<!-- components/Cards/StatCard/StatCard.vue -->
<template>
    <Card :title="title" :wrapperClass="`stats-card ${customClass}`">
      <div class="text-3xl font-bold">{{ value }}</div>
      <div :class="`text-sm ${changeColor}`">{{ changeText }}</div>
    </Card>
  </template>

<script>
import Card from '../Card.vue'

export default {
  name: 'StatCard',
  components: {
    Card
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    change: {
      type: [String, Number],
      default: 0
    },
    isPositive: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    changeColor () {
      return this.isPositive ? 'text-green-500' : 'text-red-500'
    },
    changeText () {
      const prefix = this.change >= 0 ? '+' : ''
      return `${prefix}${this.change}% vs last period`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/StatCard.vue